var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_202_45)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_202_45",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 8C20 12.4183 16.4183 16 12 16C7.58172 16 4 12.4183 4 8C4 3.58172 7.58172 0 12 0C16.4183 0 20 3.58172 20 8ZM5.38338 8C5.38338 11.6543 8.34574 14.6166 12 14.6166C15.6543 14.6166 18.6166 11.6543 18.6166 8C18.6166 4.34574 15.6543 1.38338 12 1.38338C8.34574 1.38338 5.38338 4.34574 5.38338 8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 8C20 12.4183 16.4183 16 12 16C7.58172 16 4 12.4183 4 8C4 3.58172 7.58172 0 12 0C16.4183 0 20 3.58172 20 8ZM5.38338 8C5.38338 11.6543 8.34574 14.6166 12 14.6166C15.6543 14.6166 18.6166 11.6543 18.6166 8C18.6166 4.34574 15.6543 1.38338 12 1.38338C8.34574 1.38338 5.38338 4.34574 5.38338 8Z",
    fill: "#FFF9F9",
    stroke: "#FFF9F9",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_202_45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8571 15.4286V6.28571C11.8571 5.67951 12.098 5.09812 12.5266 4.66947C12.9553 4.24082 13.5366 4 14.1429 4H14.7143M9 8.57143H14.7143",
    stroke: "#FFF9F9",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_202_45",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_45"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_45",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBook);
export default __webpack_public_path__ + "static/media/FaceBook.642076bd7eff2e6b6d8fb9849396f9c6.svg";
export { ForwardRef as ReactComponent };